<template>
  <dp-payment-create :subNavTitle="title" :capsule="capsule" :saveMessage="saveMessage"></dp-payment-create>
</template>

<script>
  import CreateTemplate from '../PRCreateTemplate.vue'
  export default {
    name: 'Capsule-Payment-Create',
    data () {
      return {
        title: this.$t('requestToPay.new_req_to_pay'),
        capsule: 'direct-payment-create',
        saveMessage: 'Draft added'
      }
    },
    components: {
      'dp-payment-create': CreateTemplate
    }
  }
</script>



// WEBPACK FOOTER //
// TPayments.vue?eaad738c